import connectWithStravaOrange from "../assets/strava/btn_connect_with_strava.png";

/**
 * Official Strava "Connect with Strava" button (orange, unmodified asset).
 * Source: https://strava.github.io/api/images/btn_connectWith.png (Strava API brand guidelines)
 */
export const StravaConnectButton = ({ onClick, disabled, connecting }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled || connecting}
    aria-label="Connect with Strava"
    data-testid="strava-connect-button"
    className="inline-block p-0 border-0 bg-transparent disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus-visible:ring-2 focus-visible:ring-[#FC5200] focus-visible:ring-offset-2 focus-visible:ring-offset-dark-surface-1"
  >
    <img
      src={connectWithStravaOrange}
      alt="Connect with Strava"
      width={461}
      height={49}
      className="h-12 w-auto max-w-full"
      style={{ aspectRatio: "461 / 49" }}
      data-testid="strava-connect-asset"
    />
  </button>
);
